module.exports = __webpack_public_path__ + "img/no-video.f64769eb.png";